import { Nullable } from '@types'

export interface POneEvent {
  id: number
  name: string
  startDate: string
  endDate: string
  logo?: string
  isRequestingEnabled: boolean
  hasCompanyProfile?: boolean
  isAttending?: boolean
  newAssetsCount?: number
  website?: string
  imported?: boolean
  hidden?: boolean
}

export enum P1PlusAccessConfigEvent {
  'full',
  'attended',
}
export interface User {
  id: number
  name: string
  firstName?: string
  lastName?: string
  email: string
  subscriptionLevel: number
  events: POneEvent[]
  companyId?: number
  profilePicture: string
  p1PlusAccessConfig?: {
    events: P1PlusAccessConfigEvent
    optionalShortlistColumns: boolean
    shortlistLimit?: number
  }
}

export interface AuthContextType {
  user?: Nullable<User & { attendEvents: Record<string, POneEvent> }>
  isAuthenticated: boolean
  isFetching: boolean
}
